import { render, staticRenderFns } from "./objectiveList.vue?vue&type=template&id=15078138&scoped=true&"
import script from "./objectiveList.vue?vue&type=script&lang=js&"
export * from "./objectiveList.vue?vue&type=script&lang=js&"
import style0 from "./objectiveList.vue?vue&type=style&index=0&id=15078138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15078138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VIcon,VRow,VTextField})
